import { render, staticRenderFns } from "./QuestionStemManagement.vue?vue&type=template&id=0137cd6e&scoped=true"
import script from "./QuestionStemManagement.vue?vue&type=script&lang=js"
export * from "./QuestionStemManagement.vue?vue&type=script&lang=js"
import style0 from "./QuestionStemManagement.vue?vue&type=style&index=0&id=0137cd6e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137cd6e",
  null
  
)

export default component.exports